import React from 'react'
import Button from './Button'
const NormalButton = props => <Button type='normal' {...props} />
const FlatButton = props => <Button type='flat' {...props} />
const PrimeButton = props => <Button type='prime' {...props} />

export { NormalButton, FlatButton, PrimeButton }
export default Button
